import WithRender from "../../templates/imageEditor/dummyImage.html";
import { mapGetters } from "vuex";

export default WithRender({
  props: ["item", "index"],
  methods: {},
  computed: {
    ...mapGetters(["getReady"]),
    ready: function () {
      return this.getReady;
    },
    baseUrl: function () {
      return this.getConfigProp("baseUrl");
    },
    renderStyle: function () {
      if (this.ready) {
        return {
          backgroundImage: "url(" + this.item.imageSrc + ")"
        };
      }
      return {};
    }
  }
});
